/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Birthday_Event_Paywall_Title_BoxInputs */

const en_birthday_event_paywall_title_box = /** @type {(inputs: Birthday_Event_Paywall_Title_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More Boxes,
More Surprises`)
};

const ar_birthday_event_paywall_title_box = /** @type {(inputs: Birthday_Event_Paywall_Title_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المزيد من الصناديق،
المزيد من المفاجآت`)
};

const de_birthday_event_paywall_title_box = /** @type {(inputs: Birthday_Event_Paywall_Title_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr Boxen,
mehr Überraschungen`)
};

const es_birthday_event_paywall_title_box = /** @type {(inputs: Birthday_Event_Paywall_Title_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más cajas,
más sorpresas`)
};

const fr_birthday_event_paywall_title_box = /** @type {(inputs: Birthday_Event_Paywall_Title_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus de boîtes,
plus de surprises`)
};

const it_birthday_event_paywall_title_box = /** @type {(inputs: Birthday_Event_Paywall_Title_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più scatole,
più sorprese`)
};

const ja_birthday_event_paywall_title_box = /** @type {(inputs: Birthday_Event_Paywall_Title_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もっとボックスを、
もっとサプライズを`)
};

const ko_birthday_event_paywall_title_box = /** @type {(inputs: Birthday_Event_Paywall_Title_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`더 많은 상자,
더 많은 서프라이즈`)
};

const pt_br_birthday_event_paywall_title_box = /** @type {(inputs: Birthday_Event_Paywall_Title_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais caixas,
mais surpresas`)
};

const ru_birthday_event_paywall_title_box = /** @type {(inputs: Birthday_Event_Paywall_Title_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Больше коробок,
больше сюрпризов`)
};

const th_birthday_event_paywall_title_box = /** @type {(inputs: Birthday_Event_Paywall_Title_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กล่องที่มากขึ้น
เซอร์ไพรส์ที่มากขึ้น`)
};

const tr_birthday_event_paywall_title_box = /** @type {(inputs: Birthday_Event_Paywall_Title_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha fazla kutu,
daha fazla sürpriz`)
};

const zh_cn_birthday_event_paywall_title_box = /** @type {(inputs: Birthday_Event_Paywall_Title_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加码蛋糕盒
让每天多一份惊喜`)
};

const zh_tw_birthday_event_paywall_title_box = /** @type {(inputs: Birthday_Event_Paywall_Title_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加碼蛋糕盒
讓每天多一份驚喜`)
};

/**
* | output |
* | --- |
* | "More Boxes, More Surprises" |
*
* @param {Birthday_Event_Paywall_Title_BoxInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const birthday_event_paywall_title_box = /** @type {((inputs?: Birthday_Event_Paywall_Title_BoxInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Birthday_Event_Paywall_Title_BoxInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_birthday_event_paywall_title_box(inputs)
	if (locale === "ar") return ar_birthday_event_paywall_title_box(inputs)
	if (locale === "de") return de_birthday_event_paywall_title_box(inputs)
	if (locale === "es") return es_birthday_event_paywall_title_box(inputs)
	if (locale === "fr") return fr_birthday_event_paywall_title_box(inputs)
	if (locale === "it") return it_birthday_event_paywall_title_box(inputs)
	if (locale === "ja") return ja_birthday_event_paywall_title_box(inputs)
	if (locale === "ko") return ko_birthday_event_paywall_title_box(inputs)
	if (locale === "pt_br") return pt_br_birthday_event_paywall_title_box(inputs)
	if (locale === "ru") return ru_birthday_event_paywall_title_box(inputs)
	if (locale === "th") return th_birthday_event_paywall_title_box(inputs)
	if (locale === "tr") return tr_birthday_event_paywall_title_box(inputs)
	if (locale === "zh_cn") return zh_cn_birthday_event_paywall_title_box(inputs)
	return zh_tw_birthday_event_paywall_title_box(inputs)
});